import { addDays, differenceInCalendarDays, endOfMonth, format, startOfMonth } from "date-fns";
import { Box, Grid, Text } from "grommet";
import _, { orderBy } from "lodash";
import * as React from "react";
import ScrollContainer from "../components/ScrollContainer";
import { CalendarViewEvent } from "./CalendarView";
import "./calendarAgenda.css";

const MonthlyAgendaView = ({ events, month }: { events: CalendarViewEvent[]; month: Date }) => {
    const [eventsPerDay, setEventsPerDay] = React.useState([] as CalendarViewEvent[]);

    React.useEffect(() => {
        newEventsArray();
    }, [events, month]);

    const newEventsArray = () => {
        let newArray = [] as CalendarViewEvent[];
        let tempEvents = events.filter((event) => event.start <= endOfMonth(month) && event.end >= startOfMonth(month)) as CalendarViewEvent[];

        if (events.length > 0) {
            orderBy(tempEvents, "start").forEach((event) => {
                let days = differenceInCalendarDays(event.end, event.start);
                for (let i = 0; i <= days; i++) {
                    let tempEvent = { ...event };
                    tempEvent.dayOfEvent = i + 1;
                    newArray = [...newArray, tempEvent];
                    tempEvent.start = addDays(tempEvent.start, i);
                }
            });

            newArray = _(newArray)
                .groupBy((e) => format(e.start, "yyyy-MM-dd"))
                .values()
                .map((dates) => {
                    dates[0].showDate = true;
                    return dates;
                })
                .flatten()
                .value();
        }

        setEventsPerDay(newArray);
    };

    return (
        <Box width={"large"} pad={{ top: "small" }} gap="xsmall">
            <Box direction="row" justify="between" align="center" pad={{ bottom: "small" }}>
                <Text size="large" weight={"bold"}>
                    {`Agenda - ${format(month, "MMMM yyyy")}`}
                </Text>
            </Box>

            <ScrollContainer direction={"-y"}>
                <Box gap="xsmall">
                    {orderBy(eventsPerDay, "start")
                        .filter((event) => event.start <= endOfMonth(month) && event.end >= startOfMonth(month))
                        .map((event, key) => (
                            <Grid key={event.id + key} columns={["12%", "88%"]} gap="small">
                                <Box>
                                    {event.showDate && (
                                        <Box>
                                            <Text size="large" weight="bold">
                                                {`${format(event.start, "dd")}`}
                                            </Text>
                                            <Text size="small" weight="bold">
                                                {`${format(event.start, "eee")}`}
                                            </Text>
                                        </Box>
                                    )}
                                </Box>

                                <Box className="event" width="medium" gap="xxsmall" border={[{ size: "medium", color: event.color, side: "left" }]} pad="small" round="xsmall">
                                    <Text size="small" weight="bold">
                                        {event.title}
                                    </Text>
                                    {!event.body?.startsWith("<") && (
                                        <Text size="small" color="background-contrast" as={"pre"}>
                                            {event.body}
                                        </Text>
                                    )}
                                    {event.body?.startsWith("<") && <Text size="small" color="background-contrast" dangerouslySetInnerHTML={{ __html: event.body || "" }}></Text>}

                                    <Box direction="row" gap="xsmall" align="center">
                                        {event.days > 0 && (
                                            <Box pad="xsmall" round="xsmall" border={{ color: "background-front", size: "small" }} color="background-contrast">
                                                <Text size="small">{`Day ${event.dayOfEvent} of ${event.days + 1}`}</Text>
                                            </Box>
                                        )}
                                        <Text size="small" color="background-contrast">
                                            {event.allDay ? `All-Day` : `${format(event.start, "hh:mm a")} - ${format(event.end, "hh:mm a")}`}
                                        </Text>
                                    </Box>
                                </Box>
                            </Grid>
                        ))}
                </Box>
            </ScrollContainer>
        </Box>
    );
};

export default MonthlyAgendaView;
